import type React from 'react';
import { Panel, PanelBody, PanelHeader } from '@itandi/itandi-bb-ui';
import { ProfileSettingVendorUser } from '~/components/specifics/vendors/settings/profiles/ProfileSettingVendorUser';
import { ProfileSettingPassword } from '~/components/specifics/vendors/settings/profiles/ProfileSettingPassword';

export const ProfileSetting: React.FC = () => (
  <Panel>
    <PanelHeader title="プロフィール詳細" />
    <PanelBody>
      <ProfileSettingVendorUser />
      <ProfileSettingPassword />
    </PanelBody>
  </Panel>
);
